import apiService from '@/api/apiService';

export const deleteRole = async (userId) => {
    const url = `/api/admin/roles/${userId}`;

    return apiService.DELETE(url);
};
